import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import messages from '../../locale/messages';
import InboxContainer from './InboxContainer';
import DashboardLayout from '../../components/Dashboard/DashboardLayout';

const title = 'Inbox';

export default function action({ store, intl }) {

  const title = intl?.formatMessage(messages.inbox);

  // From Redux Store
  const isAuthenticated = store.getState().runtime.isAuthenticated;
  const hasPhoneNumber = store.getState().account.data?.phoneNumber

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  if (!hasPhoneNumber && typeof window !== 'undefined') {
    alert("Por favor agregue su número de teléfono")
    return { redirect: '/user/edit' };
  }

  return {
    title,
    component: <UserLayout hideMenu>
      <DashboardLayout>
        <InboxContainer
          title={title}
        />
      </DashboardLayout>
    </UserLayout>,
  };
}